import gsap from "gsap";

export function initMenu() {
    let isSticky = false;

    const header       = document.querySelector(".page-header");
    const toggle       = document.querySelector("#hamburgerToggle");
    const panelMenu    = document.querySelector("#panelMenu");
    const panelOverlay = document.querySelector("#panelOverlay");
    const body         = document.body;
    const threshold = window.innerHeight / 3;
    const homeHero = document.querySelector(".home-hero");

    toggle?.addEventListener("click", toggleMenu);
    panelOverlay?.addEventListener("click", closeMenu);
    window.addEventListener("scroll", handleScroll, { passive: true });

    function getAnimateElements() {
        return panelMenu ? panelMenu.querySelectorAll(".animate-on-click") : [];
    }

    function toggleMenu() {
        if (!toggle || !panelMenu || !panelOverlay) return;

        toggle.classList.toggle("is-active");
        if (!body.classList.contains("filters-open")) {
            body.classList.toggle("no-scroll");
        }
        body.classList.toggle("menu-open");
        panelOverlay.classList.toggle("in");
        const isOpening = panelMenu.classList.toggle("in");
        header?.classList.toggle("menu-open", isOpening);

        const elementsToAnimate = getAnimateElements();
        elementsToAnimate.forEach((el, index) => {
            menuAnimation(el, index * (isOpening ? 0.05 : 0.03), isOpening ? "in" : "out");
        });
    }

    function closeMenu() {
        if (!toggle || !panelMenu || !panelOverlay) return;
        toggle.classList.remove("is-active");
        body.classList.remove("menu-open");

        if (!body.classList.contains("filters-open")) {
            body.classList.remove("no-scroll");
        }

        panelOverlay.classList.remove("in");
        panelMenu.classList.remove("in");
        header?.classList.remove("menu-open");

        const elementsToAnimate = getAnimateElements();
        elementsToAnimate.forEach((el, index) => {
            menuAnimation(el, index * 0.03, "out");
        });
    }

    function menuAnimation(el, delay = 0, direction = "in") {
        if (!el) return;
        if (direction === "in") {
            el.style.opacity = 0;
            el.style.transform = "translateY(20px)";
            el.style.transition = "none";
            requestAnimationFrame(() => {
                setTimeout(() => {
                    el.style.transition = "all 0.4s ease";
                    el.style.opacity = 1;
                    el.style.transform = "translateY(0)";
                }, delay * 1000);
            });
        } else {
            setTimeout(() => {
                el.style.transition = "all 0.3s ease";
                el.style.opacity = 0;
                el.style.transform = "translateY(20px)";
            }, delay * 1000);
        }
    }

    function showHeader() {
        if (!header || isSticky) return;
        isSticky = true;

        gsap.killTweensOf(header);
        header.classList.add("sticky"); // posizione fixed/sticky nel tuo CSS

        // appare scendendo dall’alto
        gsap.fromTo(
            header,
            { y: -100, opacity: 0 },
            { y: 0, opacity: 1, duration: 0.45, ease: "power2.out" }
        );
    }

    function hideHeader() {
        if (!header || !isSticky) return;
        isSticky = false;

        gsap.killTweensOf(header);

        // sparisce verso l’alto e poi rimuove la classe
        gsap.to(header, {
            y: -100,
            opacity: 0,
            duration: 0.35,
            ease: "power2.in",
            onComplete: () => {
                header.classList.remove("sticky");
                // opzionale: riposiziona “a riposo”
                gsap.set(header, { clearProps: "transform,opacity" });
            }
        });
    }

    function updateHeaderInverted() {
        if (!header || !homeHero) return;
        const headerH = header.getBoundingClientRect().height || 0;
        const heroRect = homeHero.getBoundingClientRect();
        const heroInView = heroRect.bottom > headerH;
        header.classList.toggle("inverted", heroInView);
    }

    function handleScroll() {
        if (document.body.classList.contains('page-template-page-about') || document.body.classList.contains('page-template-page-about-php')) {
            showHeader();
            return;
        }
        if (homeHero) updateHeaderInverted();
        const shouldShow = window.scrollY > threshold;
        if (shouldShow) showHeader();
        else hideHeader();
    }

    // esegui una prima valutazione all’avvio
    if (homeHero) updateHeaderInverted();
    handleScroll();
}
